// Upload-images path: each image becomes one brochure page, shown directly on
// the invite. Stores ordered storage paths on the event; resolves URLs for preview.

import { useRef, useState } from "react";
import { uploadImagePage, removeImagePage, resolvePageUrls } from "../../firebase/storage.js";

export default function ImageUploader({ slug, imagePages = [], onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [previews, setPreviews] = useState({}); // path -> url

  async function refreshPreviews(paths) {
    try {
      const urls = await resolvePageUrls(paths);
      const map = {};
      paths.forEach((p, i) => (map[p] = urls[i]));
      setPreviews(map);
    } catch { /* preview only */ }
  }

  async function onFiles(e) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const newPaths = [];
      for (let i = 0; i < files.length; i++) {
        const { path } = await uploadImagePage(slug, files[i]);
        newPaths.push(path);
      }
      const all = [...imagePages, ...newPaths];
      onChange(all);
      refreshPreviews(all);
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  }

  async function remove(path) {
    try { await removeImagePage(path); } catch { /* ignore */ }
    onChange(imagePages.filter((p) => p !== path));
  }

  function move(i, dir) {
    const next = [...imagePages];
    const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  }

  return (
    <div className="stack">
      <p className="muted">
        Upload images in order — each becomes one page of your invite. Reorder with
        the arrows.
      </p>
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={onFiles} disabled={busy} />
      {busy && <p className="muted">Uploading…</p>}

      <div className="stack">
        {imagePages.map((p, i) => (
          <div className="row card" key={p} style={{ padding: 12 }}>
            <div style={{ width: 64, height: 64, overflow: "hidden", borderRadius: 8, background: "var(--app-bg)" }}>
              {previews[p] && <img src={previews[p]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
            </div>
            <div className="muted" style={{ fontSize: ".85rem", overflow: "hidden", textOverflow: "ellipsis" }}>
              Page {i + 1}
            </div>
            <div className="spacer" />
            <button className="btn-ghost btn" onClick={() => move(i, -1)}>↑</button>
            <button className="btn-ghost btn" onClick={() => move(i, 1)}>↓</button>
            <button className="btn-ghost btn" onClick={() => remove(p)}>✕</button>
          </div>
        ))}
      </div>
    </div>
  );
}
